document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    const dialog = document.querySelector('.tee-dialog');
    if(dialog) {
      
      // When the pop-up is open, it can only be closed using the X. 
      // Would it be possible to adjust it so that the pop-up can also be closed when the customer clicks outside the pop-up?
      var ww = window.innerWidth || document.documentElement.clientWidth;

      if(ww > 1000) {
        if (!document.body.dataset.teePersonalizeOutsideHandlerBound) {
          document.body.dataset.teePersonalizeOutsideHandlerBound = 'true';

          document.addEventListener('pointerdown', (ev) => {
            const modal = document.querySelector('.vm--overlay[data-modal^="tee-personalize-popup"]~.vm--modal');
            if (!modal) return;

            const dialogBody = modal.querySelector('.tee-dialog-inner .tee-dialog-body');
            if (!dialogBody) return;

            const cartDrawer = document.querySelector('.cart-drawer');
            if (cartDrawer && cartDrawer.contains(ev.target)) return;

            if (!dialogBody.contains(ev.target)) {
              const closeBtn = modal.querySelector('.tee-dialog-close');
              if (closeBtn) {
                closeBtn.click();
              }
            }
          }, true);
        }
      }
      
      // Would it be possible for the Preview button and the ATC button to remain at the bottom
      const form = dialog.querySelector('.teeinblue-item--product');

      if(form) {
        const teeBlocks = form.querySelectorAll('.tee-block');
        if (teeBlocks.length >= 2 && !form.querySelector('.tee-atc-wrapper')) {
          const wrapper = document.createElement('div');
          wrapper.classList.add('tee-atc-wrapper');

          teeBlocks[0].parentNode.insertBefore(wrapper, teeBlocks[0]);
          wrapper.appendChild(teeBlocks[0]);
          wrapper.appendChild(teeBlocks[1]);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('teeinblue-event-after-cart-added', function() {
  document.dispatchEvent(new CustomEvent('cart:refresh'))
  setTimeout(function(){
    document.querySelector('a[aria-controls="cart-drawer"]').click()
  },1000)
})



